import Vue, { Component } from 'vue';
import Router, { RouteConfig } from 'vue-router';
import beforeEach from '@/util/beforeEach';
import Root from './pages/Root.vue';
import Home from '@/pages/Home.vue';

import LaunchScreen from '@/pages/top/LaunchScreen.vue';
import InputBirthday from '@/pages/top/InputBirthday.vue';
import TermsOfUse from '@/pages/top/TermsOfUse.vue';
import PersonalInformation from '@/pages/top/PersonalInformation.vue';
import PassVaccineIntroduction from '@/pages/top/PassVaccineIntroduction.vue';
import PassVaccineSelectDocument from '@/pages/top/PassVaccineSelectDocument.vue';
import ScamAlert from '@/pages/top/ScamAlert.vue';

import ApplicationCompletion from '@/pages/application/Completion.vue';
import ApplicationError from '@/pages/application/Error.vue';

import CameraBase from '@/pages/camera/CameraBase.vue';
import CameraChildIntroduction from '@/pages/camera/CameraChildIntroduction.vue';
import CameraChildShooting from '@/pages/camera/CameraChildShooting.vue';
import CameraChildError from '@/pages/camera/CameraChildError.vue';
import CameraShootTypeConfirmation from '@/pages/camera/CameraShootTypeConfirmation.vue';

import store from '@/store';

Vue.use(Router);

// 撮影画面のルート
const createRouteConfigCamera = (path: string, side: string): RouteConfig => {
  let routePath: string = `${path}/${side}`;

  // 汎用書類
  if (path === 'general-purpose-document' && side === 'page') routePath = `${path}/${side}/:gpdoc_page`;

  // 補助書類
  if (path === 'optional-document' && side === 'page') routePath = `${path}/${side}/:opdoc_term/:opdoc_page`;

  return {
    path: routePath,
    component: CameraBase,
    children: [
      {
        path: 'introduction',
        name: `${path}-${side}-introduction`,
        component: CameraChildIntroduction
      },
      {
        path: 'shooting',
        name: `${path}-${side}-shooting`,
        component: CameraChildShooting
      },
      {
        path: 'confirmation',
        name: `${path}-${side}-confirmation`,
        // Paidyの場合はPaidy用のコンポーネントを返す
        component: () => {
          return store.getters['auth/isPaidy'] && !store.getters['camera/isOpdoc'] && !store.getters['camera/isGpdoc']
            ? import('@/pages/camera/CameraChildConfirmationPaidy.vue')
            : import('@/pages/camera/CameraChildConfirmation.vue');
        }
      },
      {
        path: 'shoot-type-confirmation',
        name: `${path}-${side}-shoot-type-confirmation`,
        component: CameraShootTypeConfirmation
      },
      {
        path: 'error',
        name: `${path}-${side}-error`,
        component: CameraChildError
      }
    ]
  };
};

const router: Router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '',
      component: Root,
      children: ([] as RouteConfig[]).concat([
        // TODO: プロトタイプ実証実験用のページのため不要なら削除
        {
          path: 'home',
          name: 'home',
          component: Home
        },

        // Top
        { path: '', name: 'launch', component: LaunchScreen },
        { path: 'top/scam-alert', name: 'scam-alert', component: ScamAlert },
        { path: 'top/input-birthday', name: 'birthday', component: InputBirthday },
        { path: 'top/terms-of-use', name: 'terms', component: TermsOfUse },
        { path: 'top/personal-information', name: 'information', component: PersonalInformation },

        // special top
        {
          path: 'top/pass-vaccine-introduction',
          name: 'pass-vaccine-introduction',
          component: PassVaccineIntroduction
        },
        {
          path: 'top/pass-vaccine-select-document',
          name: 'pass-vaccine-select-document',
          component: PassVaccineSelectDocument
        },

        // 本人確認書類
        createRouteConfigCamera('identity-document', 'front'),
        createRouteConfigCamera('identity-document', 'diagonal'),
        createRouteConfigCamera('identity-document', 'back'),
        // 個人番号取得書類
        createRouteConfigCamera('mynumber-document', 'front'),
        createRouteConfigCamera('mynumber-document', 'back'),

        // 顔正面
        createRouteConfigCamera('face', 'front'),
        // 首振り
        createRouteConfigCamera('face', 'action'),

        // 汎用書類
        createRouteConfigCamera('general-purpose-document', 'page'),

        // 補助書類
        createRouteConfigCamera('optional-document', 'page'),

        // 申し込み完了画面
        {
          path: 'application/completion',
          name: 'application-completion',
          component: ApplicationCompletion
        },

        // エラー画面
        {
          path: 'application/error/:code',
          name: 'application-error',
          component: ApplicationError
        },

        // ここより上に設定のないパスへのアクセスは、404とみなしログインページへリダイレクトする
        {
          path: '*',
          redirect: { name: 'launch' }
        }

        // {
        //   path: 'about',
        //   name: 'about',
        //   // route level code-splitting
        //   // this generates a separate chunk (about.[hash].js) for this route
        //   // which is lazy-loaded when the route is visited.
        //   component: () => import(/* webpackChunkName: "about" */ './pages/About.vue'),
        // },
      ])
    }
  ]
});

router.beforeEach(beforeEach);

export default router;
